import { Action } from "@ngrx/store"

export enum LayoutActionTypes {
	ToggleView = "[Layout] toggleView"
}

export class ToggleView implements Action {
	readonly type = LayoutActionTypes.ToggleView
	constructor(public payload: boolean) {}
}

export type LayoutActions = ToggleView
